import { Stack, Skeleton, IconButton } from "@mui/material";
import { DragIndicatorRounded, Edit, MoreHoriz } from "@mui/icons-material";
type ActiveItemLoadingProps = {
  draggable?: boolean;
};
export const ActiveItemLoading = ({
  draggable
}: ActiveItemLoadingProps) => {
  return <Stack direction="row" sx={{
    bgcolor: "background.paper",
    height: 62,
    width: "100%",
    border: 1,
    borderColor: "border",
    borderRadius: 2,
    alignItems: "center"
  }} data-sentry-element="Stack" data-sentry-component="ActiveItemLoading" data-sentry-source-file="ActiveItemLoading.tsx">
      <Stack direction="row" alignItems="center" flexGrow={1} data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
        {draggable && <IconButton size="xsmall" sx={{
        cursor: "grab",
        mx: 0.25
      }} disabled>
            <DragIndicatorRounded fontSize="small" />
          </IconButton>}
        <Skeleton variant="rounded" width={40} height={40} sx={{
        ml: !draggable ? 2 : 0
      }} data-sentry-element="Skeleton" data-sentry-source-file="ActiveItemLoading.tsx" />
        <Stack gap={0.5} justifyContent="center" flexGrow={1} ml={2} data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
          <Skeleton variant="rounded" height={10} sx={{
          width: "100%",
          maxWidth: 180
        }} data-sentry-element="Skeleton" data-sentry-source-file="ActiveItemLoading.tsx" />
          <Skeleton variant="rounded" height={10} sx={{
          width: "100%",
          maxWidth: 400
        }} data-sentry-element="Skeleton" data-sentry-source-file="ActiveItemLoading.tsx" />
        </Stack>
      </Stack>
      <Stack direction="row" gap={2} mr={2} alignItems="center" data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
        <Stack gap={0.25} data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
          <Stack height={20} width={28} bgcolor="grey.100" alignItems="center" justifyContent="center" borderRadius={1} data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
            <Skeleton variant="rounded" height={10} width={20} data-sentry-element="Skeleton" data-sentry-source-file="ActiveItemLoading.tsx" />
          </Stack>
          <Stack height={20} width={28} bgcolor="grey.100" alignItems="center" justifyContent="center" borderRadius={1} data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
            <Skeleton variant="rounded" height={10} width={20} data-sentry-element="Skeleton" data-sentry-source-file="ActiveItemLoading.tsx" />
          </Stack>
        </Stack>
        <Stack direction="row" gap={1} data-sentry-element="Stack" data-sentry-source-file="ActiveItemLoading.tsx">
          <IconButton disabled size="xsmall" data-sentry-element="IconButton" data-sentry-source-file="ActiveItemLoading.tsx">
            <Edit fontSize="small" data-sentry-element="Edit" data-sentry-source-file="ActiveItemLoading.tsx" />
          </IconButton>
          <IconButton disabled size="xsmall" data-sentry-element="IconButton" data-sentry-source-file="ActiveItemLoading.tsx">
            <MoreHoriz fontSize="small" data-sentry-element="MoreHoriz" data-sentry-source-file="ActiveItemLoading.tsx" />
          </IconButton>
        </Stack>
      </Stack>
    </Stack>;
};